import React, { useEffect, useMemo, useState } from 'react';
import ConfigHeaderNav from '../../components/HeadersNav/ConfigHeaderNav';
import { Box, Card, CircularProgress, Grid, TextField, Typography } from '@mui/material';
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import ApiService from '../../functions/apiService';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import MyTable from '../../components/Schedule/MyTable';
import PaginationComponent from '../../components/Pagination/Pagination';
import EditConfig from '../../components/System/EditConfig';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import SystemHeaderNav from '../../components/HeadersNav/SystemHeaderNav';

export default function ConfigSystem() {
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [rows, setRows] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [editItem, setEditItem] = useState();
  let columns = [
    {
      field: 'Var',
      headerName: 'Var',
      sortable: false,
      flex: 1,
      minWidth: 250,
      filterable: false,
      // renderCell: (params) => (selectedShift == undefined || (selectedShift && selectedShift == params.row.Shift_Code)) && <CheckboxRenderer setRowSelectionModel={setRowSelectionModel} rowSelectionModel={rowSelectionModel} setSelectedShift={setSelectedShift} selectedPatch={selectedPatch} setSelectedPatch={setSelectedPatch} {...params} />,
    },
    {
      field: 'Type',
      headerName: 'Type',
      sortable: false,
      flex: 1,
      minWidth: 100,
      filterable: false,
    },
    {
      field: 'Options',
      headerName: 'Options',
      sortable: false,
      flex: 1,
      minWidth: 200,
      filterable: false,
    },
    {
      field: 'Effective_Date',
      headerName: 'Effective Date',
      sortable: false,
      flex: 1,
      minWidth: 200,
      filterable: false,
    },
    {
      field: 'Value',
      headerName: 'Value',
      sortable: false,
      flex: 1,
      minWidth: 100,
      filterable: false,
    },
    {
      field: 'Action',
      headerName: 'Action',
      sortable: false,
      flex: 1,
      minWidth: 100,
      filterable: false,
      renderCell: params => {
        return (
          // <div className="d-flex justify-content-center ">
          <div style={{ width: '50%' }} className='d-flex justify-content-between action-btn-color'>
            <button className='btn bg-transparent px-1' onClick={() => editRow(params.row)}>
              <EditOutlinedIcon />
            </button>
          </div>
          // </div>
        );
      },
    },
  ];
  let loadData = (searchText = '', page = 1) => {
    setLoading(true);
    if (searchText == '') {
      setSearch('');
    }
    ApiService.get('/getAllConfig', { page: page, search: searchText }, 'getAllConfig')
      .then(({ data }) => {
        setLoading(false);
        // console.log('data',data.data);
        setRows(data.data);
      })
      .catch(error => {
        setLoading(false);
      });
  };
  let editRow = row => {
    setEditMode(true);
    setEditItem(row);
  };
  useEffect(() => {
    loadData();
  }, []);
  let FilterData = () => {
    loadData(search, 1);
  };
  const PageChanged = (e, page) => {
    loadData(search, page);
  };
  let CloseEditMode = () => {
    setEditMode(false);
    setEditItem();
  };
  let handleKeyPress = e => {
    if (e.key === 'Enter') {
      // console.log('Enter key pressed');
      // Perform the action you want when Enter key is pressed
      FilterData();
    }
  };
  return (
    <>
      {/* <ConfigHeaderNav /> */}
      <SystemHeaderNav />
      <Card className='shadow p-3 ' style={{ marginTop: '1rem' }}>
        <Typography variant='h5'>System variable</Typography>
        <Grid container spacing={2} columns={{ xs: 4, sm: 4, md: 8, lg: 8 }} className='my-2'>
          {!editMode && (
            <Grid item xs={4} md={8}>
              <div className='d-flex'>
                <TextField
                  className='mx-2 '
                  color={'secondary'}
                  label='Search Var'
                  value={search}
                  InputProps={{
                    sx: {
                      height: '48px',
                    },
                  }}
                  onChange={e => setSearch(e.target.value)}
                  onKeyDown={handleKeyPress}
                />
                <ButtonTheme color={'primary'} onClick={FilterData}>
                  Filter
                </ButtonTheme>
              </div>
            </Grid>
          )}
          <Grid item xs={4} md={8}>
            {!loading && !editMode && (
              <div>
                <MyTable
                  rows={rows.data}
                  columns={columns}
                  checkboxSelection={false}
                  hideFooter={true}
                />
                <br />
                <PaginationComponent results={rows} pageChanged={PageChanged} />
              </div>
            )}
            {loading && (
              <Box className='w-100 h-100 d-flex justify-content-center align-items-center'>
                <CircularProgress />
              </Box>
            )}
            {editMode && editItem && (
              <>
                <button onClick={CloseEditMode} className='btn bg-transparent border-0 my-2'>
                  <ArrowBackIosIcon /> Back
                </button>
                <EditConfig editItem={editItem} CloseEditMode={CloseEditMode} loadData={loadData} />
              </>
            )}
          </Grid>
        </Grid>
      </Card>
    </>
  );
}
